import React from 'react';
import {useDispatch, useSelector} from 'react-redux';
import ModalWindow from '../ModalWindow/ModalWindow';
import {selectPlayers, selectTurnOrder} from '../../../redux/reducers/sharedStateReducer/selectors';
import {hideInitiativeModal} from '../../../redux/actions';
import {getPlayerHexColor} from '../../../utils/players/getPlayerHexColor';
import './InitiativeModal.css';
import ModalButton from "../ModalWindow/ModalButton/ModalButton";

const InitiativeModal = () => {
  const dispatch = useDispatch();
  // const modalShown = useSelector(selectShowInitiativeModal);
  const players = useSelector(selectPlayers);
  const turnOrder = useSelector(selectTurnOrder);

  // Disabled InitiativeModal show due to SetupPlayersModal.
  // Consider removing InitiativeModal code in future refactoring.
  const showModalFinal = false; // && modalShown && players && turnOrder && turnOrder.length !== 0;

  if (!showModalFinal) {
    return null;
  }

  const initiativePlayerId = turnOrder[0];
  const initiativePlayer = players.find(p => p.id === initiativePlayerId);

  if (!initiativePlayer) {
    return null;
  }

  const playerColor = getPlayerHexColor(initiativePlayer.color);

  const handleClose = () => {
    dispatch(hideInitiativeModal());
  };

  return (
    <ModalWindow handleClose={handleClose}>
      <div className="initiative-modal-header">
        <h2>
          <span
            className="initiative-modal-player-name"
            style={{color: playerColor}}
          >
            {initiativePlayer.name}
          </span>
        </h2>
        <h2>
          {'получает инициативу!'}
        </h2>
      </div>
      <div className="initiative-modal-content">
        <img
          src={`/img/icons/initiative.png`}
          alt={'close'}
        />
      </div>
      <div className="initiative-modal-footer">
        <ModalButton
          onClick={handleClose}
          text={'Начать матч'}
        />
      </div>
    </ModalWindow>
  );
};

export default InitiativeModal;
